import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { api, formatPrice } from "@/lib/api";
import { useSEO, useSettings } from "@/lib/hooks";

export default function PricingPage() {
  const s = useSettings();
  const [t, setT] = useState(null);
  useSEO({ title: "Tarifs dépannage et remorquage — Depann7", description: "Tous nos tarifs de dépannage, remorquage et transport de véhicules en Île-de-France. Prix transparents et sans surprise." });

  useEffect(() => {
    api.get("/settings/public").then((r) => setT(r.data)).catch(() => {});
  }, []);

  if (!t) return <div className="text-center py-32 text-txt-500">Chargement...</div>;

  const lines = [
    { label: "Forfait dépannage simple (prise en charge)", value: formatPrice(t.forfait_base) },
    { label: "Prix par kilomètre", value: `${(t.prix_km).toFixed(2).replace(".", ",")} €/km` },
    { label: "Tarif minimum d'intervention", value: formatPrice(t.prix_minimum) },
    { label: "Sortie de fourrière", value: `${formatPrice(t.prix_sortie_fourriere)} + km` },
    { label: "Transport de véhicule", value: `${formatPrice(t.prix_transport_vehicule)} + km` },
    { label: "Majoration nuit (22h - 7h)", value: `+ ${formatPrice(t.majoration_nuit)}` },
    { label: "Majoration dimanche / jour férié", value: `+ ${formatPrice(t.majoration_dimanche)}` },
    { label: "Majoration accident", value: `+ ${formatPrice(t.majoration_accident)}` },
    { label: "Majoration accès difficile", value: `+ ${formatPrice(t.majoration_acces_difficile)}` },
  ];

  return (
    <div className="bg-white">
      <div className="bg-ink-900 text-white py-14">
        <div className="max-w-6xl mx-auto px-4 lg:px-6">
          <h1 className="text-3xl lg:text-4xl font-extrabold">Tarifs</h1>
          <p className="text-ink-300 mt-2 max-w-2xl">Une grille tarifaire claire pour vos dépannages, remorquages et transports en Île-de-France.</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 lg:px-6 py-12">
        <div className="bg-white border border-surface-200 rounded-2xl overflow-hidden shadow-card">
          {lines.map((l, i) => (
            <div key={l.label} className={`flex items-center justify-between px-6 py-4 ${i < lines.length - 1 ? "border-b border-surface-100" : ""}`}>
              <span className="text-txt-700 text-sm">{l.label}</span>
              <span className="text-lg font-extrabold text-brand">{l.value}</span>
            </div>
          ))}
        </div>
        <p className="text-txt-500 text-sm mt-6 text-center max-w-xl mx-auto">
          Les tarifs sont indicatifs. Le prix final dépend de la distance, de l'accessibilité, du type de véhicule et de l'urgence. TVA {t.tva}% incluse.
        </p>
        <div className="mt-6 text-center">
          <a href={`tel:${s?.company_phone_raw || ""}`} className="inline-flex bg-brand hover:bg-brand-600 text-white font-bold rounded-xl px-6 py-3.5 items-center gap-2 transition-colors">
            <Phone size={18} /> Appeler pour un devis
          </a>
        </div>
      </div>
    </div>
  );
}
